var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-form-radio',_vm._g(_vm._b({},'b-form-radio',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }